import React from 'react'
import { componentList } from '@/test_data/sample-component-data'
import { MiniAppText } from '@/ui/molecules/mini-app-text'
import { MiniAppProps } from './types'
import { useTabData } from '@sourcepilot/ui/framework/state/session-data';
import { ComponentData } from '@/types/component-from-page';

export function ComponentsMiniApp({ containerWidth }: MiniAppProps) {
  const [hoveredItem, setHoveredItem] = React.useState<string | null>(null);
  const { activeTab, navigateToTab } = useTabData();

  return (
    <div className="px-4">
      <ul className="p-0 list-none">
        {componentList.map((component: ComponentData) => (
          <li key={component.slug} className="p-auto m-auto leading-none">
            <button 
              className="text-left hover:underline w-full"
              onClick={() => navigateToTab({
                id: component.slug,
                title: component.name,
                contentType: 'component',
              })}
              onMouseEnter={() => setHoveredItem(component.slug)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <MiniAppText
                className="text-sm" 
                containerWidth={containerWidth - 32}
                // isActive={component.pathname === activeTab?.pathname}
                // isHovered={component.pathname === hoveredItem}
              >
                {component.name}
              </MiniAppText>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

